export const REPORT_NAME_MIN_LENGTH = 3;
export const REPORT_NAME_MAX_LENGTH = 50;

export const normalizeReportName = (rawName: string): string =>
  (rawName || "").trim().replace(/\s+/g, " ");

export const validateReportName = (rawName: string): string | null => {
  const name = normalizeReportName(rawName);
  if (!name) return null;
  if (name.length < REPORT_NAME_MIN_LENGTH)
    return `Il nome deve contenere almeno ${REPORT_NAME_MIN_LENGTH} caratteri.`;
  if (name.length > REPORT_NAME_MAX_LENGTH)
    return `Il nome può contenere al massimo ${REPORT_NAME_MAX_LENGTH} caratteri.`;
  if (!/^[a-zA-Z0-9À-ÖØ-öø-ÿ ()[\]&./\\-]+$/.test(name))
    return "Il nome può contenere solo lettere, numeri, spazi e i caratteri ( ) [ ] & - . / \\";
  return null;
};

export const sanitizeReportName = (rawName: string): string | null => {
  const name = normalizeReportName(rawName);
  if (!name || validateReportName(name)) return null;
  return name;
};

type ReportNameValidation = {
  error: string | null;
  canSave: boolean;
};

export const reportNameValidation = (rawName: string): ReportNameValidation => {
  const error = validateReportName(rawName);
  return { error, canSave: !error && normalizeReportName(rawName) !== "" };
};
